import { componentResolver } from '@/routes/helpers';

export default [
  {
    path: 'channels',
    name: 'accounts.channels',
    components: {
      default: componentResolver('accounts/channels/index.vue'),
    },
    props: { default: true },
    meta: {
      transitionName: 'slide',
    },
  },
];
